import ActivityCardSkeleton from '@/components/ui/ActivityCardSkeleton';
import { container, sectionPadding } from '@/lib/ds';

/**
 * Platzhalter für nachgeladene Home-Sektionen.
 * Reserve-Höhe entspricht der echten Sektion, damit beim Nachladen nichts springt.
 * variant: 'cards' (Aktivitäten-Karten) | 'sliders' (Kategorie-/Alters-Karten) | 'text' (FAQ)
 */
export default function SectionSkeleton({ variant = 'cards', background = 'bg-white' }) {
  return (
    <section className={`${sectionPadding} ${background}`}>
      <div className={container}>
        <div className="h-8 w-72 max-w-full rounded shimmer mb-3" />
        <div className="h-5 w-96 max-w-full rounded shimmer mb-6" />

        {variant === 'text' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
            {[0, 1].map((col) => (
              <div key={col} className="space-y-3">
                <div className="h-4 w-32 rounded shimmer" />
                <div className="h-8 w-3/4 rounded shimmer" />
                <div className="h-3 rounded shimmer" />
                <div className="h-3 w-5/6 rounded shimmer" />
                <div className="h-3 w-2/3 rounded shimmer" />
              </div>
            ))}
          </div>
        )}

        {variant === 'cards' && (
          <div className="flex gap-4 overflow-hidden">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="shrink-0 basis-4/5 sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                <ActivityCardSkeleton />
              </div>
            ))}
          </div>
        )}

        {variant === 'sliders' && (
          <div className="flex gap-4 overflow-hidden">
            {[0, 1, 2, 3].map((i) => (
              <div
                key={i}
                className="shrink-0 rounded-2xl shimmer w-[193px] h-[280px] lg:w-full lg:h-[420px]"
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}